module.exports = __webpack_public_path__ + "img/20240802144554329cN.3efb6a3f.png";